import { Reveal, SectionHeading } from "./Reveal";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import { FAQS } from "../data/site";

export const Faq = () => (
    <section
        id="faq"
        data-testid="faq-section"
        className="py-24 sm:py-36 bg-charcoal border-y border-white/10"
    >
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-20">
            <div>
                <SectionHeading
                    index="06"
                    eyebrow="FAQ"
                    title="Domande frequenti."
                    testId="faq-heading"
                />
                <Reveal delay={0.1}>
                    <p className="mt-6 text-white/60 leading-relaxed max-w-sm">
                        Non trovi la risposta che cercavi? Scrivici su WhatsApp:
                        rispondiamo in italiano, in genere entro pochi minuti.
                    </p>
                </Reveal>
            </div>

            <Reveal delay={0.1}>
                <Accordion type="single" collapsible data-testid="faq-accordion">
                    {FAQS.map((item, i) => (
                        <AccordionItem
                            key={i}
                            value={`faq-${i}`}
                            className="border-b border-white/10"
                        >
                            <AccordionTrigger
                                data-testid={`faq-question-${i}`}
                                className="text-left text-white hover:text-gold hover:no-underline py-6 text-base sm:text-lg font-normal transition-colors duration-300"
                            >
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent
                                data-testid={`faq-answer-${i}`}
                                className="text-white/60 leading-relaxed pb-6"
                            >
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);
